import { AgencySignupApprovalCard } from '../../components/admin/AgencySignupApprovalCard'
import { ToastProvider } from '../../components/Toast'

function AdminAgencyApprovalsInner() {
  return (
    <div className="space-y-6">
      <AgencySignupApprovalCard />
    </div>
  )
}

export default function AdminAgencyApprovalsPage() {
  return (
    <ToastProvider>
      <AdminAgencyApprovalsInner />
    </ToastProvider>
  )
}
